export const Role = [
    { id: 'ROLE_ADMIN', name: 'Admin' },
    { id: 'ROLE_DOCTOR', name: 'Doctor' }
];
